import api from './api';

export const directMessageService = {
  // Get all direct messages (Admin/Manager)
  getAll: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/direct-messages${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  // Get message details with recipient statuses (Admin/Manager)
  getMessageStatus: async (messageId) => {
    const response = await api.get(`/direct-messages/${messageId}/recipients`);
    return response.data;
  },

  // Get current user's pending messages (Employee - for Windows app)
  getMyPending: async () => {
    const response = await api.get('/direct-messages/my-pending');
    return response.data;
  },

  // Get current user's message history (Employee)
  getMyHistory: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/direct-messages/my-history${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  // Send a new direct message (Admin/Manager)
  send: async (messageData) => {
    const response = await api.post('/direct-messages', messageData);
    return response.data;
  },

  // Acknowledge a message (Employee)
  acknowledge: async (messageId) => {
    const response = await api.put(`/direct-messages/${messageId}/acknowledge`);
    return response.data;
  },

  // Resend message to unacknowledged recipients (Admin/Manager)
  resend: async (messageId) => {
    const response = await api.post(`/direct-messages/${messageId}/resend`);
    return response.data;
  },

  // Deactivate a message (Admin/Manager)
  deactivate: async (messageId) => {
    const response = await api.put(`/direct-messages/${messageId}/deactivate`);
    return response.data;
  },

  // Permanently delete a message (Admin ONLY)
  delete: async (messageId) => {
    const response = await api.delete(`/direct-messages/${messageId}`);
    return response.data;
  }
};

export default directMessageService;
